import { useState, useEffect } from "react";
export function useFetch(url) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    let ignore = false;
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((json) => {
        if (!ignore) {
          setData(Array.isArray(json) ? json : []);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!ignore) {
          setData([]);
          setError(true);
          setLoading(false);
        }
      });

    return () => { ignore = true };
  }, [url]);
  return { data, loading, error };
}
